(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pelsfri-product-details')) {
 customElements.define('pelsfri-product-details', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   this.social = this.querySelector('.pfp--social');
   this.buy = this.querySelector('.buy-buttons-block');
   if (!this.social || !this.buy) return;
   this.marker = document.createComment('Pelsfred social desktop position');
   this.social.before(this.marker);
   this.media = matchMedia('(max-width:749px)');
   this.update = () => {
    if (this.media.matches) this.buy.after(this.social);
    else this.marker.after(this.social);
   };
   this.media.addEventListener('change', this.update, {signal:this.abort.signal});
   this.update();
  }
  disconnectedCallback() {
   this.abort?.abort();this.abort=null;
   if(this.marker?.parentNode){this.marker.after(this.social);this.marker.remove();}
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pelsfred-purchase-gallery'))customElements.define('pelsfred-purchase-gallery',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.addEventListener('click',e=>{const b=e.target.closest('[data-gallery-index]');if(!b){if(e.target.closest('[data-close-gallery-zoom]'))this.querySelector('dialog')?.close();const opener=e.target.closest('[data-enlarge-gallery]');if(opener){const dialog=this.querySelector('dialog');const image=opener.querySelector('img');dialog.querySelector('img').src=image.currentSrc||image.src;dialog.querySelector('img').alt=image.alt;dialog.showModal()}return}const index=Number(b.dataset.galleryIndex);this.querySelectorAll('[data-gallery-slide]').forEach((s,i)=>{s.hidden=i!==index;if(i!==index)s.querySelector('video')?.pause()});this.querySelectorAll('[data-gallery-index]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)))},{signal:this.abort.signal})}
disconnectedCallback(){this.abort?.abort();this.querySelectorAll('video').forEach(v=>v.pause())}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pelsfri-bundle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pelsfri-bundle'))customElements.define('pelsfri-bundle',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.addEventListener('change',e=>{if(!e.target.matches('input[type=radio]'))return;const details=this.closest('.product-details'),form=details?.querySelector('form[data-type="add-to-cart-form"]'),id=form?.querySelector('input[name="id"]');if(!id)return;id.value=e.target.value;let quantity=form.querySelector('input[name="quantity"]');if(quantity)quantity.value='1';const atc=details.querySelector('.pfp--atc');if(atc)atc.dataset.price=e.target.dataset.price;const price=details.querySelector('.pfp-atc-price');if(price)price.textContent='- '+e.target.dataset.price;const sticky=this.closest('.shopify-section')?.querySelector('.sticky-add-to-cart__bar');if(sticky){const title=sticky.querySelector('.sticky-add-to-cart__title'),amount=sticky.querySelector('.price'),image=sticky.querySelector('img'),button=sticky.querySelector('button');if(title)title.textContent=e.target.dataset.title;if(amount)amount.textContent=e.target.dataset.price;if(image){image.src=e.target.dataset.image;image.alt=e.target.dataset.title}button?.setAttribute('aria-label',e.target.dataset.title+', '+e.target.dataset.price)}},{signal:this.abort.signal})}
 disconnectedCallback(){this.abort?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pelsfri-product-block"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pelsfri-product-block'))customElements.define('pelsfri-product-block',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();let opt={signal:this.abort.signal};if(this.dataset.kind==='tabs'){this.addEventListener('click',e=>{let t=e.target.closest('[role=tab]');if(t)this.select(t)},opt);this.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)||!e.target.matches('[role=tab]'))return;e.preventDefault();let t=[...this.querySelectorAll('[role=tab]')],i=t.indexOf(e.target),n=e.key==='Home'?0:e.key==='End'?t.length-1:(i+(e.key==='ArrowRight'?1:-1)+t.length)%t.length;this.select(t[n]);t[n].focus()},opt)}if(this.dataset.kind==='banner')this.setupStock();if(this.dataset.kind==='social')this.setupFaces();if(this.dataset.kind==='atc'){this.button=this.closest('.product-details')?.querySelector('.add-to-cart-button');this.paintButton();this.observer=new MutationObserver(()=>this.paintButton());if(this.button)this.observer.observe(this.button,{childList:true,subtree:true});}}
 setupStock(){
  const indicator=this.querySelector('[data-stock-state]'),data=this.querySelector('[data-stock-variants]'),details=this.closest('.product-details');
  if(!indicator||!data||!details)return;
  const variants=JSON.parse(data.textContent),text=indicator.querySelector('[data-stock-text]');
  const update=id=>{
   const variant=variants.find(item=>item.id===String(id));if(!variant)return;
   const d=indicator.dataset,quantity=Number(variant.quantity);
   let state='available';
   if(!variant.available)state='sold-out';
   else if(variant.tracked){if(quantity<=0)state='preorder';else if(quantity<=Number(d.stockCritical))state='critical';else if(quantity<=Number(d.stockLimit))state='low';}
   indicator.dataset.stockState=state;indicator.dataset.stockVariant=variant.id;
   text.textContent=state==='sold-out'?d.stockSoldOut:state==='preorder'?d.stockPreorder:state==='critical'||state==='low'?`${d.stockPrefix} ${quantity} ${d.stockSuffix}`:d.stockAvailable;
  };
  details.addEventListener('change',event=>{if(event.target.matches('.pfbundle input[type="radio"],input[name="id"]'))update(event.target.value)},{signal:this.abort.signal});
  update(details.querySelector('.pfbundle input:checked')?.value||indicator.dataset.stockVariant);
 }
 setupFaces(){
  this.faces=[...this.querySelectorAll('.pfp__faces img')];this.offset=0;this.avatarAnimations=[];this.avatarVisible=false;this.faceMotion=matchMedia('(prefers-reduced-motion:reduce)');
  const sync=()=>{clearInterval(this.faceTimer);this.avatarAnimations.forEach(a=>a.cancel());this.paintFaces();if(this.faces.length>3&&!this.faceMotion.matches&&!document.hidden&&this.avatarVisible)this.faceTimer=setInterval(()=>this.advanceFaces(),1800)};
  this.faceMotion.addEventListener('change',sync,{signal:this.abort.signal});document.addEventListener('visibilitychange',sync,{signal:this.abort.signal});
  this.faceObserver=new IntersectionObserver(entries=>{this.avatarVisible=entries[0].isIntersecting;sync()});this.faceObserver.observe(this.querySelector('.pfp__faces'));this.paintFaces();
 }
 paintFaces(){this.faces.forEach((f,i)=>{const slot=(i-this.offset+this.faces.length)%this.faces.length,visible=slot<3;f.style.transform=`translateX(${visible?slot*22.4:67.2}px) scale(${visible?1:.94})`;f.style.opacity=visible?'1':'0';f.style.zIndex=String(visible?3-slot:0)})}
 advanceFaces(){
  if(document.hidden||!this.avatarVisible||this.faceMotion.matches)return;
  this.avatarAnimations.forEach(a=>a.cancel());this.avatarAnimations=[];const previous=this.offset;this.offset=(this.offset+1)%this.faces.length;this.paintFaces();
  this.faces.forEach((f,i)=>{const slot=(i-previous+this.faces.length)%this.faces.length;if(slot>3)return;const entering=slot===3,leaving=slot===0;f.style.zIndex=String(leaving?4:4-slot);this.avatarAnimations.push(f.animate([
   {transform:`translateX(${slot*22.4}px) scale(${entering?.94:1})`,opacity:entering?0:1},
   {transform:`translateX(${(slot-1)*22.4}px) scale(${leaving?.94:1})`,opacity:leaving?0:1}
  ],{duration:650,easing:'cubic-bezier(.4,0,.2,1)'}))});
 }
 select(t){this.querySelectorAll('[role=tab]').forEach(b=>{let yes=b===t;b.setAttribute('aria-selected',String(yes));b.tabIndex=yes?0:-1;this.querySelector('#'+CSS.escape(b.getAttribute('aria-controls'))).hidden=!yes})}
 paintButton(){
  if(!this.button||this.button.disabled)return;
  const text=this.button.querySelector('[ref="addToCartButtonText"],.add-to-cart-text');
  if(!text)return;
  const label=text.querySelector('.pfp-atc-label');
  if(label&&label.textContent!==this.dataset.buy)label.textContent=this.dataset.buy;
  const prices=[...this.button.querySelectorAll('.pfp-atc-price')];
  let price=prices.shift();prices.forEach(el=>el.remove());
  if(!price){price=document.createElement('span');price.className='pfp-atc-price';text.append(price);}
  const value='– '+this.dataset.price;
  if(price.textContent!==value)price.textContent=value;
 }
 disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);clearInterval(this.faceTimer);this.faceObserver?.disconnect();this.avatarAnimations?.forEach(a=>a.cancel());this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pelsfri-product-videos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pelsfri-product-videos')){
  customElements.define('pelsfri-product-videos',class extends HTMLElement{

    connectedCallback(){
      this.abort?.abort();
      this.abort=new AbortController();

      const options={signal:this.abort.signal};

      this.dialog=this.querySelector('dialog');
      this.player=this.querySelector('.pfpv__player');

      this.items=[
        ...this.querySelectorAll('[data-open-video]')
      ];

      this.previews=this.items.map(
        item=>item.querySelector('video')
      );

      this.motion=matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      if(!this.items.length){
        this.hidden=true;
        return;
      }

      // Hold alle små videoer permanent lydløse.
      this.previews.forEach(video=>{
        video.muted=true;
        video.defaultMuted=true;
        video.volume=0;
        video.setAttribute('muted','');
        video.controls=false;
        video.loop=true;
        video.playsInline=true;
      });

      // Popup-afspilleren er også permanent lydløs.
      this.player.muted=true;
      this.player.defaultMuted=true;
      this.player.volume=0;
      this.player.controls=false;

      this.visiblePreviews=new Set();

      this.observer=new IntersectionObserver(entries=>{
        for(const entry of entries){
          if(entry.isIntersecting){
            this.visiblePreviews.add(entry.target);
          }else{
            this.visiblePreviews.delete(entry.target);
          }
        }

        this.updatePreviews();
      },{
        threshold:.15
      });

      this.previews.forEach(video=>{
        this.observer.observe(video);

        video.addEventListener('play',()=>{
          video.muted=true;
          video.volume=0;

          if(!this.previewAllowed(video)){
            video.pause();
          }
        },options);

        video.addEventListener('volumechange',()=>{
          if(!video.muted||video.volume!==0){
            video.muted=true;
            video.volume=0;
          }
        },options);
      });

      // Popup-lyd kan ikke aktiveres via afspilleren.
      this.player.addEventListener('volumechange',()=>{
        if(!this.player.muted||this.player.volume!==0){
          this.player.muted=true;
          this.player.volume=0;
        }
      },options);

      document.addEventListener(
        'visibilitychange',
        ()=>{
          this.updatePreviews();

          if(document.hidden){
            this.player.pause();
          }
        },
        options
      );

      this.motion.addEventListener(
        'change',
        ()=>this.updatePreviews(),
        options
      );

      this.addEventListener('click',event=>{
        const button=event.target.closest('button');

        if(!button)return;

        if(button.matches('[data-open-video]')){
          this.opener=button;
          this.index=this.items.indexOf(button);

          this.dialog.showModal();
          this.updatePreviews();
          this.playCurrent();
        }

        else if(button.matches('[data-toggle-play]')){
          if(this.player.paused){
            this.player.muted=true;
            this.player.volume=0;
            this.player.play().catch(()=>{});
          }else{
            this.player.pause();
          }
        }

        else if(button.matches('.pfpv__close')){
          this.dialog.close();
        }

        else if(button.hasAttribute('data-direction')){
          this.move(Number(button.dataset.direction));
        }
      },options);

      this.seek=this.querySelector(
        '.pfpv__transport input'
      );

      this.seek.addEventListener('input',()=>{
        if(Number.isFinite(this.player.duration)){
          this.player.currentTime=
            this.player.duration*
            Number(this.seek.value)/100;
        }
      },options);

      const update=()=>{
        const playing=!this.player.paused;

        const play=this.querySelector(
          '[data-toggle-play]'
        );

        play.textContent=playing?'Ⅱ':'▶';

        play.setAttribute(
          'aria-label',
          playing
            ?'Sæt video på pause'
            :'Afspil video'
        );

        const format=t=>
          `${Math.floor((t||0)/60)}:${String(
            Math.floor((t||0)%60)
          ).padStart(2,'0')}`;

        this.querySelector('.pfpv__time').textContent=
          `${format(this.player.currentTime)} / ${
            format(
              Number.isFinite(this.player.duration)
                ?this.player.duration
                :0
            )
          }`;

        this.seek.value=this.player.duration
          ?this.player.currentTime/
           this.player.duration*100
          :0;
      };

      [
        'play',
        'pause',
        'timeupdate',
        'loadedmetadata',
        'volumechange',
        'emptied'
      ].forEach(name=>
        this.player.addEventListener(
          name,
          update,
          options
        )
      );

      this.dialog.addEventListener('click',event=>{
        if(event.target===this.dialog){
          const r=this.dialog.getBoundingClientRect();

          if(
            event.clientX<r.left||
            event.clientX>r.right||
            event.clientY<r.top||
            event.clientY>r.bottom
          ){
            this.dialog.close();
          }
        }
      },options);

      this.dialog.addEventListener('keydown',event=>{
        if(
          event.target!==this.seek&&
          ['ArrowUp','ArrowDown'].includes(event.key)
        ){
          event.preventDefault();

          this.move(
            event.key==='ArrowUp'?-1:1
          );
        }
      },options);

      this.dialog.addEventListener('close',()=>{
        this.player.pause();

        this.player.muted=true;
        this.player.volume=0;

        this.updatePreviews();

        this.opener?.focus({
          preventScroll:true
        });
      },options);
    }

    previewAllowed(video){
      return this.visiblePreviews.has(video)
        &&!document.hidden
        &&!this.dialog.open
        &&!this.motion.matches;
    }

    updatePreviews(){
      this.previews.forEach(video=>{
        video.muted=true;
        video.volume=0;

        if(this.previewAllowed(video)){
          if(video.paused){
            video.play().then(()=>{
              if(!this.previewAllowed(video)){
                video.pause();
              }
            }).catch(()=>{});
          }
        }else{
          video.pause();
        }
      });
    }

    move(direction){
      this.index=(
        this.index+
        direction+
        this.items.length
      )%this.items.length;

      this.playCurrent();
    }

    playCurrent(){
      const preview=this.previews[this.index];

      const source=
        preview.querySelector(
          'source[type="video/mp4"]'
        )||
        preview.querySelector('source');

      this.player.pause();

      this.player.muted=true;
      this.player.volume=0;

      this.player.src=
        source?.src||
        preview.currentSrc||
        preview.src;

      this.player.poster=preview.poster;

      this.player.load();

      // Ingen lyd heller ikke efter videoskift.
      this.player.muted=true;
      this.player.volume=0;

      this.player.play().catch(()=>{});

      this.querySelector(
        '.pfpv__status'
      ).textContent=
        `Video ${this.index+1} af ${this.items.length}`;
    }

    disconnectedCallback(){
      this.abort?.abort();
      this.observer?.disconnect();

      this.previews?.forEach(
        video=>video.pause()
      );

      this.player?.pause();

      if(this.dialog?.open){
        this.dialog.close();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
